import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import Slider from "react-slick";
import downloadbanner from "../../../images/Inner Page/NavBanner.png";
import './../NavBanner/NavBanner.css'

function NavBanner() {
  return (
    <section className="banner-sc download-banner">
        {/* <section className="navdividend-banner-main">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="banner-content-download">
                  <h1>NAVs And Dividends</h1>
                 </div>
              </Col>
            </Row>
          </Container>
        </section> */}

               <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={downloadbanner}
                  alt="NAV and IDCW Banner"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">NAV & IDCW</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
  )
}

export default NavBanner